import gql from 'graphql-tag';

export const GET_BACKEND_SERVER_TOKEN = gql`
  query GetBackendServerToken {
    token: getBackendServerToken
  }
`;
